@if (isLoading$ | async) {
  <div class="global-loading-overlay">
    <div class="global-loading-container">
      <mat-spinner diameter="50" color="accent"></mat-spinner>
      @if (message$ | async; as message) {
        <div class="loading-message">
          {{ message }}
        </div>
      }
    </div>
  </div>
}
